/**
 * Préférences d'interface valables **le temps de la session** (v0.49.0, A98) :
 * `sessionStorage` quand il existe, sinon une mémoire de module. Rien ne
 * survit à la fermeture de l'onglet, et rien n'entre dans la sauvegarde.
 *
 * Même contrat que `ui/prefs.ts` : chaque accès est gardé par `try/catch`
 * (mode privé, stockage bloqué) — l'écran ne casse jamais, la préférence
 * retombe alors sur la mémoire du module.
 */

/** Repli en mémoire : actif quand `sessionStorage` est absent ou refuse l'écriture. */
const memory = new Map<string, string>();

export function readSessionPref(key: string): string | null {
  try {
    if (typeof sessionStorage !== 'undefined') {
      const stored = sessionStorage.getItem(key);
      if (stored !== null) return stored;
    }
  } catch {
    /* stockage indisponible : la mémoire du module prend le relais */
  }
  return memory.get(key) ?? null;
}

export function writeSessionPref(key: string, value: string): void {
  memory.set(key, value);
  try {
    if (typeof sessionStorage !== 'undefined') sessionStorage.setItem(key, value);
  } catch {
    /* la mémoire du module suffit */
  }
}

export function removeSessionPref(key: string): void {
  memory.delete(key);
  try {
    if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}
